(function(){
  var menu=document.querySelector('[data-menu]');
  var nav=document.querySelector('[data-nav]');
  if(menu&&nav) menu.addEventListener('click',function(){nav.classList.toggle('open');});
  document.querySelectorAll('[data-search]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var box=document.querySelector('[data-searchbox]');
      if(box) box.classList.toggle('open');
    });
  });

  // Cart drawer quantity: add "− N +" to every drawer line rendered by sam-cart.js (no Liquid change needed).
  (function(){
    var lines=document.querySelector('[data-lines]');
    if(!lines||!window.MutationObserver) return;
    var qtyByKey={}, busy=false, seq=0;
    function decorate(){
      lines.querySelectorAll('[data-remove]').forEach(function(rm){
        var key=rm.getAttribute('data-remove');
        var q=qtyByKey[key];
        if(q==null) return;
        var box=rm.parentNode.querySelector('.qty-d');
        if(box && box.getAttribute('data-q')===String(q)) return;
        if(box) box.remove();
        box=document.createElement('div');
        box.className='qty-d';
        box.setAttribute('data-q',String(q));
        box.innerHTML="<button type='button' class='qd-btn' data-qd='"+key+"' data-step='1' aria-label='\u05d4\u05d5\u05e1\u05e4\u05ea \u05d9\u05d7\u05d9\u05d3\u05d4'>+</button>"+
          "<span class='qd-n' aria-live='polite'>"+q+"</span>"+
          "<button type='button' class='qd-btn' data-qd='"+key+"' data-step='-1' aria-label='\u05d4\u05e4\u05d7\u05ea\u05ea \u05d9\u05d7\u05d9\u05d3\u05d4'"+(q<=1?' disabled':'')+">\u2212</button>";
        rm.parentNode.insertBefore(box,rm);
      });
    }
    function sync(){
      var my=++seq;
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
        if(my!==seq) return;
        qtyByKey={};
        (cart.items||[]).forEach(function(l){ qtyByKey[l.key]=l.quantity; });
        decorate();
      }).catch(function(){});
    }
    new MutationObserver(function(){
      if(lines.querySelector('[data-remove]') && !lines.querySelector('.qty-d')) sync();
      else decorate();
    }).observe(lines,{childList:true});
    lines.addEventListener('click',function(e){
      var btn=e.target.closest('[data-qd]');
      if(!btn||busy) return;
      var key=btn.getAttribute('data-qd');
      var next=(qtyByKey[key]||1)+Number(btn.getAttribute('data-step'));
      if(next<1) return;
      busy=true;
      btn.parentNode.querySelectorAll('button').forEach(function(b){ b.disabled=true; });
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:next})})
        .then(function(r){ return r.json(); })
        .catch(function(){})
        .then(function(){
          busy=false;
          var box=btn.parentNode; if(box) box.removeAttribute('data-q');
          if(window.samOpenCart) window.samOpenCart(); else sync();
        });
    });
  })();

  function bindCart(){}
  var root=document.querySelector('[data-product]');
  if(!root) return;
  var variants=[];
  var chosen={};
  var raw=root.querySelector('[data-variant-json]');
  try { variants=JSON.parse(raw?raw.textContent:'[]'); } catch(e) { variants=[]; }
  variants.forEach(function(v){ v.o=v.o||[]; });

  function bindThumbs(){
    root.querySelectorAll('.thumb').forEach(function(btn){
      btn.onclick=function(){
        var main=root.querySelector('[data-main]');
        if(main) main.src=btn.getAttribute('data-src');
        root.querySelectorAll('.thumb').forEach(function(el){el.classList.remove('on');});
        btn.classList.add('on');
      };
    });
  }
  function match(){
    var need=root.querySelectorAll('.size-box').length;
    if(Object.keys(chosen).length<need) return null;
    for(var i=0;i<variants.length;i++){
      var v=variants[i];
      var ok=true;
      Object.keys(chosen).forEach(function(key){
        if(v.o[Number(key)]!==chosen[key]) ok=false;
      });
      if(ok) return v;
    }
    return null;
  }
  function paint(){
    var item=match();
    var add=root.querySelector('[data-add]');
    var pay=root.querySelector('[data-pay]');
    var ready=!!(item&&item.ok);
    if(item&&item.img){
      var main=root.querySelector('[data-main]');
      if(main) main.src=item.img;
    }
    if(item&&item.price!=null){
      var priceEl=root.querySelector('[data-price]');
      if(priceEl){
        var formatted='\u20aa'+(item.price/100).toFixed(2);
        var hot=priceEl.querySelector('.hot');
        if(hot) hot.textContent=formatted;
        else if(!priceEl.querySelector('s')) priceEl.textContent=formatted;
      }
    }
    if(add){
      add.disabled=!ready;
      add.textContent=ready?'\u05d4\u05d5\u05e1\u05d9\u05e4\u05d9 \u05dc\u05e2\u05d2\u05dc\u05d4':(item?'\u05d4\u05de\u05d9\u05d3\u05d4 \u05d0\u05d6\u05dc\u05d4':'\u05d1\u05d7\u05e8\u05d9 \u05de\u05d9\u05d3\u05d4');
    }
    if(pay) pay.disabled=!ready;
    return item;
  }
  root.querySelectorAll('[data-option]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=btn.getAttribute('data-option');
      chosen[key]=btn.getAttribute('data-value');
      root.querySelectorAll('[data-option="'+key+'"]').forEach(function(el){
        el.classList.toggle('on', el===btn);
      });
      var span=btn.parentElement&&btn.parentElement.previousElementSibling&&btn.parentElement.previousElementSibling.querySelector('span');
      if(span) span.textContent='\u00b7 '+btn.getAttribute('data-value');
      paint();
    });
  });
  root.querySelectorAll('.size-box').forEach(function(box){
    var btns=box.querySelectorAll('[data-option]');
    if(btns.length===1) btns[0].click();
  });
  function go(checkout){
    var item=paint();
    if(!item||!item.ok){
      var box=root.querySelector('[data-sizes]');
      if(box) box.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    function add(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.id,quantity:1})})
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); });
    }
    if(!checkout){
      add().then(function(){ if(window.samOpenCart) window.samOpenCart(); });
      return;
    }
    // buy now: never add a second unit of a variant that is already in the cart
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        return (cart.items||[]).some(function(l){ return String(l.variant_id)===String(item.id); });
      }, function(){ return false; })
      .then(function(has){ return has?null:add(); })
      .then(function(){ location.href='/checkout'; }, function(){ /* add failed (e.g. sold out): stay, same as before */ });
  }
  var addBtn=root.querySelector('[data-add]');
  var payBtn=root.querySelector('[data-pay]');
  if(addBtn) addBtn.addEventListener('click',function(){ go(false); });
  if(payBtn) payBtn.addEventListener('click',function(){ go(true); });
  bindThumbs();
  root.querySelectorAll('.size-box').forEach(function(box){
    var label=box.querySelector('p');
    var text=label?label.textContent:'';
    if(text.indexOf('\u05e6\u05d1\u05e2')===-1) return;
    var btn=box.querySelector('[data-option]');
    if(!btn) return;
    btn.classList.add('on');
    chosen[btn.getAttribute('data-option')]=btn.getAttribute('data-value');
    var span=label.querySelector('span');
    if(span) span.textContent='\u00b7 '+btn.getAttribute('data-value');
  });
  paint();

  var colorUrls=['data-c0','data-c1','data-c2','data-c3'].map(function(attr){return root.getAttribute(attr);}).filter(Boolean);
  if(!colorUrls.length && root.getAttribute('data-colors')) colorUrls=[root.getAttribute('data-colors')];
  if(colorUrls.length){
    Promise.all(colorUrls.map(function(u){return fetch(u).then(function(r){return r.json();}).catch(function(){return {};});})).then(function(parts){
      var map={};
      parts.forEach(function(part){ if(part&&typeof part==='object'){ Object.keys(part).forEach(function(k){ map[k]=part[k]; }); } });
      var title=root.getAttribute('data-title');
      var handle=root.getAttribute('data-handle');
      var group=map[title]||[];
      if(group.length<2) return;
      var box=root.querySelector('[data-swatches]');
      box.innerHTML="<p style='font-weight:700;margin:16px 0 0'>\u05e6\u05d1\u05e2</p><div class='swatches'>"+group.map(function(item){
        return "<button type='button' class='swatch"+(item.h===handle?' on':'')+"' data-color='"+item.h+"'><img src='"+item.img+"?width=160' alt=''></button>";
      }).join('')+"</div><p class='muted'>"+group.length+" \u05e6\u05d1\u05e2\u05d9\u05dd \u05dc\u05d0\u05d5\u05ea\u05d5 \u05d3\u05d2\u05dd</p>";
      box.querySelectorAll('[data-color]').forEach(function(btn){
        btn.addEventListener('click',function(){ location.href='/products/'+btn.getAttribute('data-color'); });
      });
    }).catch(function(){});
  }

  // Shared helpers. Piece type and English model name come from the product title (handles are often misleading).
  var samKinds=[['set','\u05e1\u05d8'],['top','\u05d8\u05d5\u05e4'],['top','\u05d7\u05d6\u05d9\u05d9'],['legs','\u05d8\u05d9\u05d9\u05e5'],['shorts','\u05e9\u05d5\u05e8\u05d8'],['skirt','\u05d7\u05e6\u05d0\u05d9\u05ea'],['body','\u05d1\u05d2\u05d3 \u05d2\u05d5\u05e3'],['jacket','\u05d2[\'\u2019\u05f3]?\u05e7\u05d8'],['none','\u05d1\u05e7\u05d1\u05d5\u05e7'],['none','\u05d2\u05e8\u05d1']];
  function samKind(title){
    var kind='', at=-1;
    samKinds.forEach(function(k){
      var m=new RegExp('(^|[\\s\\-])'+k[1]).exec(String(title||''));
      if(m && (at===-1 || m.index<at)){ at=m.index; kind=k[0]; }
    });
    return kind;
  }
  function samLatin(s){ return String(s||'').match(/[A-Za-z][A-Za-z0-9]*(?:[\s-]+[A-Za-z0-9]+)*/g)||[]; }
  function samCompact(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]/g,''); }
  function samKeys(item){
    var out=[];
    [item.name].concat(item.handles||[]).forEach(function(s){ samLatin(s).forEach(function(r){ out.push(samCompact(r)); }); });
    return out;
  }
  // Charts whose name or handle model part equals the English model name; single-word fallback (e.g. Pink Candy -> Candy).
  function samChartsFor(name,list){
    var model=samCompact(name);
    if(!model) return [];
    var found=(list||[]).filter(function(item){ return samKeys(item).indexOf(model)!==-1; });
    if(!found.length){
      var words=String(name).toLowerCase().split(/[\s-]+/);
      found=(list||[]).filter(function(item){ var k=samKeys(item); return words.some(function(w){ return w.length>=3 && k.indexOf(w)!==-1; }); });
    }
    return found;
  }
  // A table is a shorts table when every garment length ('\u05d0\u05d5\u05e8\u05da') is under 60 cm.
  function samShortTable(t){
    var col=-1;
    (t.headers||[]).forEach(function(h,i){ if(String(h).indexOf('\u05d0\u05d5\u05e8\u05da')!==-1) col=i; });
    if(col<0) return false;
    var vals=(t.rows||[]).map(function(r){ return parseFloat(r[col]); }).filter(function(n){ return !isNaN(n); });
    return vals.length>0 && Math.max.apply(null,vals)<60;
  }
  // Bottom length: 'short' (shorts), 'long' (full-length leggings), '' (no leggings bottom or unknown). Sets use their size chart.
  function samBottom(title,charts){
    var k=samKind(title);
    if(k==='shorts') return 'short';
    if(k==='legs') return String(title).indexOf('\u05e7\u05e6\u05e8')!==-1 ? 'short' : 'long';
    if(k!=='set') return '';
    var legs=[];
    samChartsFor(samLatin(title)[0]||'',charts).forEach(function(c){
      (c.tables||[]).forEach(function(t){ if(t.title && /\u05d8\u05d9\u05d9\u05e5|\u05e9\u05d5\u05e8\u05d8/.test(t.title)) legs.push(t); });
    });
    if(!legs.length) return '';
    return legs.every(samShortTable) ? 'short' : 'long';
  }

  var chartRoot=root.querySelector('[data-charts]');
  var chartsReady=chartRoot ? Promise.all([fetch(chartRoot.getAttribute('data-a')).then(function(r){return r.text();}), fetch(chartRoot.getAttribute('data-b')).then(function(r){return r.text();})]).then(function(parts){ return JSON.parse(parts[0]+parts[1]); }) : Promise.resolve([]);
  if(chartRoot){
    chartsReady.then(function(charts){
      var handle=chartRoot.getAttribute('data-handle')||'';
      var title=root.getAttribute('data-title')||'';
      var kind=samKind(title);
      var isShort=kind==='shorts' || title.indexOf('\u05e7\u05e6\u05e8')!==-1;
      if(kind==='shorts') kind='legs';
      if(!kind || kind==='none') return;
      var want={top:/\u05d8\u05d5\u05e4|\u05d7\u05d6\u05d9\u05d9/,legs:/\u05d8\u05d9\u05d9\u05e5|\u05e9\u05d5\u05e8\u05d8|\u05d7\u05e6\u05d0\u05d9\u05ea/,skirt:/\u05d7\u05e6\u05d0\u05d9\u05ea|\u05d8\u05d9\u05d9\u05e5|\u05e9\u05d5\u05e8\u05d8/,body:/\u05d1\u05d2\u05d3 \u05d2\u05d5\u05e3/,jacket:/\u05d2['\u2019\u05f3]?\u05e7\u05d8/}[kind];
      var shortTable=samShortTable;
      function pick(list){
        var out=want ? (list||[]).filter(function(t){ return t.title && want.test(t.title); }) : (list||[]);
        if(kind==='legs' && !isShort) out=out.filter(function(t){ return !shortTable(t); });
        return out;
      }
      function hasHandle(item){ return (item.handles||[]).indexOf(handle)!==-1; }
      var usable=(charts||[]).filter(function(item){ return item.tables && item.tables.length; });
      var name=samLatin(title)[0]||'', found=[];
      if(name){
        found=samChartsFor(name,usable);
      } else {
        found=usable.filter(hasHandle);
      }
      var chart=null;
      found.forEach(function(item){ if(!chart && hasHandle(item) && pick(item.tables).length) chart=item; });
      found.forEach(function(item){ if(!chart && pick(item.tables).length) chart=item; });
      if(!chart) return;
      var tables=pick(chart.tables);
      var label={top:'\u05d8\u05d5\u05e4',legs:'\u05d8\u05d9\u05d9\u05e5',skirt:'\u05d7\u05e6\u05d0\u05d9\u05ea',body:'\u05d1\u05d2\u05d3 \u05d2\u05d5\u05e3',jacket:'\u05d2\u05f3\u05e7\u05d8'}[kind]||chart.name;
      chartRoot.innerHTML="<h2 style='font-size:14px;margin:24px 0 8px'>\u05d8\u05d1\u05dc\u05ea \u05de\u05d9\u05d3\u05d5\u05ea</h2><p class='muted'>"+label+". \u05d4\u05d4\u05d9\u05e7\u05e4\u05d9\u05dd \u05d4\u05dd \u05de\u05d9\u05d3\u05ea \u05d4\u05d2\u05d5\u05e3. \u05d4\u05d0\u05d5\u05e8\u05da \u05d4\u05d5\u05d0 \u05d0\u05d5\u05e8\u05da \u05d4\u05d1\u05d2\u05d3.</p>"+tables.map(function(table){
        var head='<tr>'+table.headers.map(function(h){return '<th>'+h+'</th>';}).join('')+'</tr>';
        var body=table.rows.map(function(row){return '<tr>'+row.map(function(cell){return "<td dir='ltr'>"+cell+'</td>';}).join('')+'</tr>';}).join('');
        return "<h3 style='font-size:14px'>"+table.title+"</h3><table class='chart'>"+head+body+'</table>';
      }).join('')+'<h3 class="how">כיצד תמדדי את עצמך</h3><ul class="measure">'+'<li><strong>חזה.</strong> הניחי את סרט המדידה סביב החלק הרחב ביותר של החזה, מתחת לזרועות.</li>'+'<li><strong>מותניים.</strong> מדדי סביב קו המותניים, בגובה הטבור.</li>'+'<li><strong>ירכיים.</strong> מדדי סביב החלק הרחב ביותר של הירך.</li>'+'<li><strong>אורך פנימי.</strong> מדדי את הרגל מבפנים, מהמפשעה ועד למטה.</li></ul>';
    }).catch(function(){});
  }

  var look=root.querySelector('[data-look]');
  if(look){
    function esc(s){return String(s).replace(/&/g,'&'+'amp;').replace(/</g,'&'+'lt;').replace(/"/g,'&'+'quot;');}
    var lookTitle=look.getAttribute('data-title')||'';
    var lookHandle=look.getAttribute('data-handle')||'';
    var lookKind=samKind(lookTitle);
    var lookName=samLatin(lookTitle)[0]||'';
    function allProducts(page,acc){
      return fetch('/collections/all/products.json?limit=250&page='+page).then(function(r){return r.json();}).then(function(data){
        var list=(data&&data.products)||[];
        acc=acc.concat(list);
        return (list.length===250 && page<4) ? allProducts(page+1,acc) : acc;
      });
    }
    if(lookName && lookKind && lookKind!=='none'){
      Promise.all([allProducts(1,[]), chartsReady.catch(function(){return [];})]).then(function(res){
        var products=res[0]||[], charts=res[1]||[];
        var model=samCompact(lookName), family=samChartsFor(lookName,charts);
        function colorOf(p){
          var o=((p&&p.options)||[]).filter(function(x){ return /color|\u05e6\u05d1\u05e2/i.test(String(x.name||'')); })[0];
          return o && o.values && o.values.length ? String(o.values[0]).trim() : '';
        }
        function inStock(p){ return (p.variants||[]).some(function(v){ return v.available; }); }
        var self=products.filter(function(p){ return p && p.handle===lookHandle; })[0];
        var color=colorOf(self), lookBottom=samBottom(lookTitle,charts);
        var best={}, order=[];
        products.forEach(function(p){
          if(!p || p.handle===lookHandle || !inStock(p)) return;
          var k=samKind(p.title);
          if(!k || k==='none' || k===lookKind) return;
          var n=samLatin(p.title)[0]||'';
          if(!n) return;
          var exact=samCompact(n)===model;
          // Sets may also match through the size-chart family (e.g. Eclipse pieces -> Espresso set). Other pieces: exact model only.
          if(!exact && !(k==='set' && samChartsFor(n,charts).some(function(c){ return family.indexOf(c)!==-1; }))) return;
          // Never pair full-length leggings with shorts (pieces or sets), in either direction.
          var b=samBottom(p.title,charts);
          if(lookBottom && b && lookBottom!==b) return;
          var score=(exact?4:0)+(color && colorOf(p)===color?1:0);
          if(!best[k]){ best[k]={p:p,s:score}; order.push(k); }
          else if(score>best[k].s) best[k]={p:p,s:score};
        });
        order.sort(function(a,b){ return (a==='set'?0:1)-(b==='set'?0:1); });
        var items=order.slice(0,4).map(function(k){ return best[k].p; });
        if(!items.length) return;
        look.innerHTML='<h2 class="look-title">השלימי את הלוק</h2><div class="look-row">'+items.map(function(p){
          var img=(p.images&&p.images[0]&&p.images[0].src)||'';
          if(img) img+=(img.indexOf('?')>=0?'&':'?')+'width=480';
          var price=(p.variants&&p.variants[0]&&p.variants[0].price)||'';
          var name=String(p.title||'').split(' - ')[0];
          return '<a class="look-card" href="/products/'+p.handle+'">'+(img?'<img src="'+img+'" alt="">':'')+'<span>'+esc(name)+'</span><b>₪'+price+'</b></a>';
        }).join('')+'</div>';
      }).catch(function(){});
    }
  }

})();
